import { AxiosError } from 'axios';
import { GET_EXAM_CONFIGURATION_FEATURE_TYPE_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_EXAM_CONFIGURATION_FEATURE_TYPE_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ExamTypeModel {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetFeatureType = ({ uuid, onSuccess, onError }: Input) => {
  const getFeatureType = async () => {
    const res = await axiosClient.get<any>(GET_EXAM_CONFIGURATION_FEATURE_TYPE_URL(uuid));
    return res.data;
  };

  return useCustomQuery([GET_EXAM_CONFIGURATION_FEATURE_TYPE_QUERY_KEY, uuid], getFeatureType, {
    onSuccess,
    onError,
    enabled: !!uuid,
  });
};
